"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GEOGRAPHIC_SCOPE = void 0;
exports.GEOGRAPHIC_SCOPE = {
    world: 'world',
    country: 'country',
};
